// ---------------------------------------------------------------------------
// DRINKS MENU — EDITABLE DATA. Approved Barverse lineup (cocktails first).
// No prices, no invented items: only confirmed drinks are listed. Categories or
// items not yet finalized stay empty with an editable note.
// ---------------------------------------------------------------------------
export const DRINK_CATEGORIES = [
  {
    id: "signature-cocktails",
    label: "Signature Cocktails",
    items: [
      { name: "Lime Cucumber Breeze", style: "Tequila base", accent: "flame" },
      { name: "Citrus Lemon Punch", style: "Vodka base", accent: "gold" },
      { name: "Hibiscus Lime Punch", style: "Gin base", accent: "sky" },
      { name: "Melon Lime Margarita", style: "Tequila base", accent: "pink" },
    ],
  },
  {
    id: "core-favorites",
    label: "Core Favorites",
    items: [
      { name: "House Margarita" },
      { name: "Paloma", style: "with Jarritos Grapefruit" },
      { name: "Mojito" },
      { name: "Cosmopolitan" },
      { name: "Aperol Spritz" },
      { name: "St Germain Spritz" },
      { name: "Mimosa" },
      { name: "Old Fashioned" },
    ],
  },
  {
    id: "draft-beer",
    label: "Draft Beer",
    items: [
      { name: "Modelo Especial" },
      { name: "Michelob Ultra" },
      { name: "Blue Moon" },
      { name: "Lagunitas IPA" },
    ],
  },
  {
    id: "bottled-beer",
    label: "Bottled Beer",
    items: [{ name: "Stella Artois" }, { name: "Bud Light" }, { name: "Pacifico" }],
  },
  {
    id: "wine",
    label: "Wine",
    items: [],
    note: "Selection being finalized — add items here.",
  },
  {
    id: "tequila",
    label: "Tequila",
    groups: [
      {
        label: "Blanco",
        items: [
          { name: "El Jimador" },
          { name: "Don Julio Blanco" },
          { name: "Maestro Dobel Diamante" },
        ],
      },
      {
        label: "Reposado",
        items: [{ name: "El Jimador" }, { name: "Don Julio Reposado" }],
      },
    ],
  },
  {
    id: "vodka",
    label: "Vodka",
    items: [{ name: "Tito's" }, { name: "Grey Goose" }],
  },
  {
    id: "whiskey-bourbon",
    label: "Whiskey & Bourbon",
    items: [],
    note: "Selection being finalized — add items here.",
  },
  {
    id: "rum",
    label: "Rum",
    items: [],
    note: "Selection being finalized — add items here.",
  },
  {
    id: "gin",
    label: "Gin",
    items: [],
    note: "Selection being finalized — add items here.",
  },
  {
    id: "liqueurs",
    label: "Liqueurs",
    items: [],
    note: "Selection being finalized — add items here.",
  },
  {
    id: "zero-proof",
    label: "Zero Proof",
    items: [],
    note: "Being finalized alongside the Tacoverse zero-proof program — add items here.",
  },
];

// Exclusive mocktail → cocktail conversions (identified by the brand).
// NAMES ONLY — recipes/ingredients/methods are never shown on the website.
export const MOCKTAIL_COCKTAIL_PAIRS = [
  { mocktail: "Green Glow", cocktail: "Cucumber Crush" },
  { mocktail: "Citrus Smash", cocktail: "Golden Hour" },
  { mocktail: "Hibiscus Heat", cocktail: "Pretty in Pink" },
  { mocktail: "Melon Margarita", cocktail: "Melonita" },
];
